// 引入request
import request from "@/utils/request";

//查询比赛类型
export function getPetition() {
    return request({
      url: '/app/type/list/',
      method: 'get',
    })
}

//生成比赛题目
export function getCreate(uid) {
    return request({
      url: '/contest/createContest/'+uid,
      method: 'post',
    })
}

//验证
export function getVerify(data) {
    return request({
      url: '/contest/isMemberHavePermission',
      method: 'get',
      params:data,
    })
}



//提交1111
export function posebmit(data) {
    return request({
      url: '/system/result',
      method: 'post',
      data:data,
    })
}

//获取排行数据
export function getShuFfle(data) {
  return request({
    url: '/contest/selectExamRanking',
    method: 'post',
    data:data,
  })
}


//查询最后一次考试/活动
export function getActivity(state,type) {
  return request({
    url: '/contest/selectExam/'+state+'/'+type,
    method: 'post',
  })
}

//查询活动排行榜
export function ExamRanking(data) {
  return request({
    url: '/contest/selectTestRanking',
    method: 'post',
    data:data,
  })
}

//查询活动排行榜
export function SearchMedal(data) {
  return request({
    url: '/contest/selectMemberMedal',
    method: 'post',
    data:data,
  })
}









